export const PropertiesActionTypes = {
  GET_PROPERTY_LIST_START: "GET_PROPERTY_LIST_START",
  GET_PROPERTY_LIST_SUCCESS: "GET_PROPERTY_LIST_SUCCESS",
  GET_PROPERTY_LIST_FAILURE: "GET_PROPERTY_LIST_FAILURE",
  SET_STATE_LIST: "SET_STATE_LIST",
  SET_CITY_LIST: "SET_CITY_LIST",
  SET_PROPERTY_LIST: "SET_PROPERTY_LIST",
  SET_STATE: "SET_STATE",
  SET_CITY: "SET_CITY",
  SET_PROPERTY: "SET_PROPERTY",
  GET_PROPERTY_DATA_START: "GET_PROPERTY_DATA_START",
  GET_PROPERTY_DATA_SUCCESS: "GET_PROPERTY_DATA_SUCCESS",
  GET_PROPERTY_DATA_FAILURE: "GET_PROPERTY_DATA_FAILURE",
  CREATE_BOOKING_START: "CREATE_BOOKING_START",
  CREATE_BOOKING_SUCCESS: "CREATE_BOOKING_SUCCESS",
  CREATE_BOOKING_FAILURE: "CREATE_BOOKING_FAILURE",
};
